module.exports = __webpack_public_path__ + "0015bd1238c3d8d57035c84a911a66a3.jpg";